import z from "zod";
import createSchemaUtils from "../../helpers/createSchemaUtils";
import { QueryFilterSchema, SortOptionSchema } from "../QueryModels";
import { SafeNameSchema } from "../common";

const ODataQueryExpandsSchema = z.union([
    SafeNameSchema.describe("An OData expand for a specific navigation property field."),
    z.object({
        custom: z.string().nonempty()
    }).describe("A custom OData expand string that will be used as-is in the OData query."),
]);
/**
 * An array of OData expands for navigation property fields.
 * These expands will be included in the OData query to retrieve related entities.
 * Each expand can be either a string representing the navigation property field name,
 * or an object with a 'custom' property containing a custom OData expand string.
 * @example
 * // Example of using navigation property field names
 * const expands: ODataQueryExpands = ["Parent", "Children"];
 * // Example of using custom OData expand strings
 * const expands: ODataQueryExpands = [{ custom: "Parent($select=Id,Name)" }, { custom: "Children($filter=IsActive eq true)" }];
 */
export type ODataQueryExpands = z.infer<typeof ODataQueryExpandsSchema>;
export const ODataQueryExpands = createSchemaUtils(ODataQueryExpandsSchema);

//#region ODataQueryDatasource
export const ODataQueryDatasourceSchema = z.object({
    entity: SafeNameSchema,
    primaryFilter: QueryFilterSchema.optional(),
    expands: ODataQueryExpandsSchema.array().optional(),
    sortBy: SortOptionSchema.array().optional()
});
export type ODataQueryDatasource = z.infer<typeof ODataQueryDatasourceSchema>;
export const ODataQueryDatasource = createSchemaUtils(ODataQueryDatasourceSchema);
//#endregion

